
import Swiper from 'vux/src/components/swiper/swiper.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'

import Scroll from '@/components/scroller'
import Storage from '@/storage'
import config from '@/config'
import { getListsdetail, getListsread, getArticleView, selectComment, addComment, cancelLiked, addLiked } from '@/api/youzheng'
import { addPartyCount } from '@/api/jfhl.js'
import { operateCreditlist, getUserAccount } from '@/api/user'
import { getaddlog } from '@/api/hgfw'
import icovote1 from '@/assets/icon_dianzan.png'
import icovote2 from '@/assets/icon_dianzan2.png'
import icopinglun from '@/assets/icon_pinglun.png'
export default {
name: 'articleDetail',
components: {
Swiper,
XTextarea,
Group,
XButton,
Scroll
},
data () {
return {
baseUrl: config.baseUrl,
obj: {},
icopinglun: icopinglun,
icovote1: icovote1,
icovote2: icovote2,
comment: '',
like: {
count: 0,
islike: 1
},
owner_type: config.owner_type,
artid: this.$route.params.artid,
commentsList: [],
readnum: '',
istime: false,
starttime: '',
endtime: '',
page: 1,
rows: 20,
notFirstLoad: false,
loadMoreDom: null
}
},
computed: {
accountid () {
return this.$store.state.user.accountid
},
userid () {
return this.$store.state.user.userid
}
},
created () {
this.addcount()
this.addCredit()
this.getContent()
},
mounted () {
this.loadMoreDom = this.$el.querySelector('.load-more')
this.listDom = this.$el.querySelector('.list-scroll')
this.getPingLun('refresh')
},
methods: {

isCurrentTime (begin, end) {
let currentTime = new Date()
let beginTime = new Date(begin)
let endTime = new Date(end)
if (currentTime < beginTime) {
this.istime = false
this.$vux.alert.show({
content: '活动还未开始'
})
return false
}
if (currentTime >= endTime) {
this.istime = false
this.$vux.alert.show({
content: '活动已结束'
})
return false
}
this.istime = true
},
/* 添加积分 */
addCredit () {
if (this.accountid !== '' && this.accountid != null) {
if (this.artid && parseInt(this.artid) === 2005) {
operateCreditlist({
accountid: this.accountid,
rulecode: 'party_rule01',
credit: 1,
owner_type: this.owner_type,
relationtype: 2,
relationid: 1,
terminaltype: 2
}).then(res => { })
} else {
operateCreditlist({
accountid: this.accountid,
rulecode: 'party_rule',
credit: 5,
owner_type: this.owner_type,
relationtype: 2,
relationid: 1,
terminaltype: 2
}).then(res => { })
}
}
},

addcount () {
addPartyCount({
partyid: this.artid,
accoutid: this.accountid,
credittype: 1
}).then(res => {
})
},

getContent () {
getArticleView({
artid: this.artid
}).then(res => {
this.obj = res.obj
this.starttime = res.obj.sttime
this.endtime = res.obj.edtime
document.title = res.obj.title
this.isCurrentTime(this.starttime, this.endtime)
})
},

submit () {
if (this.comment !== '') {
addComment({
openid: this.userid,
context: this.comment,
artid: this.artid
}).then(res => {
this.comment = ''
this.$vux.toast.text('提交成功', 'middle')
this.getPingLun('submit')
})
} else {
this.$vux.toast.text('请填写评论信息', 'middle')
}
},

getPingLun (type, done) {
let scrollid = this.commentsList.length > 0 ? this.commentsList[this.commentsList.length - 1].comid : 0
if (type === 'refresh' || type === 'submit') {
scrollid = 0
}
selectComment({
openid: this.userid,
artid: this.artid,
page: this.page,
rows: this.rows,
scrollid: scrollid
}).then(res => {
if (res.obj != null) {
if (type === 'submit') {
this.commentsList = []
}
if (type === 'refresh' || type === 'search') {
this.commentsList = []
this.listDom.scrollTop = 0
}
if (res.obj !== '' && res.obj.length > 0) {
res.obj.forEach(item => {
this.commentsList.push(item)
})
}
if ((res.obj.length === 0 || res.obj.length < this.rows) || (this.page === 1 && res.obj.length < this.rows)) {
this.loadMoreDom.innerText = '我也是有底线的～o～'
setTimeout(() => {
this.loadMoreDom.style.display = 'none'
}, 2000)
}
} else {
this.loadMoreDom.style.display = 'none'
}
done && done()
})
},

refresh (done) {
this.page = 1
this.loadMoreDom.innerText = '加载中...'
this.getPingLun('refresh', done)
},

loadMore (done) {

this.getPingLun('more', done)
},

add (likedId, comid, index) {
if (likedId === null || likedId === '') {
addLiked({
openid: this.userid,
comid: comid,
artid: this.artid
}).then(res => {
this.$set(this.commentsList[index], 'likedId', res.obj)
this.$set(this.commentsList[index], 'likedNum', this.commentsList[index].likedNum + 1)

this.$vux.toast.text('点赞+1', 'middle')
})
} else {
cancelLiked({
openid: this.userid,
comid: comid,
artid: this.artid
}).then(res => {
this.$set(this.commentsList[index], 'likedId', res.obj)
this.$set(this.commentsList[index], 'likedNum', this.commentsList[index].likedNum - 1)

this.$vux.toast.text('您已取消点赞', 'middle')
})
}
}
}
}
